export default __webpack_public_path__ + "static/RootSans-3Light-619b0a31793f1d911491ef145be14836.woff2";